import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withHandlers, withState } from 'recompose';
import moment from 'moment';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';
import InvoicesPage from '../components/InvoicesPage';

export const GET_SUBSCRIPTION_QUERY = gql`
  query getSubscription($salon: ID!) {
    viewer {
      id
      ... on Administrator {
        salon(id: $salon) {
          id
          subscriptionDetails {
            id
            status
            currentPeriodStart
            currentPeriodEnd
            created
            currency
            amount
            canceledAt
          }
        }
      }
    }
  }
`;

const CANCEL_STRIPE_SUBSCRIPTION_MUTATION = gql`
  mutation cancelStripeSubscription($input: StripeIntentInput!) {
    cancelStripeSubscription(input: $input) {
      success
    }
  }
`;

const withData = graphql(GET_SUBSCRIPTION_QUERY, {
    options: ownProps => ({
        variables: {
            salon: ownProps.salon,
        },
        fetchPolicy: 'network-only',
    }),
    props: ({ data: { viewer, loading } }) => ({
        loading,
        subscription: get(viewer, 'salon.subscriptionDetails', {}),
    }),
});

const withCancelling = withState('cancelling', 'setCancelling', false);

const withMutation = graphql(CANCEL_STRIPE_SUBSCRIPTION_MUTATION, {
    options: ownProps => ({
        variables: {
            salon: ownProps.salon,
        },
    }),
    props: ({ mutate, ownProps: { salon, intl, subscription, setCancelling } }) => ({
        cancelStripeSubscription: () => {
            if (
                !window.confirm(
                    intl
                        .formatMessage({
                            id: 'pages.administrator.InvoicesPage.confirmCancelText',
                            defaultMessage:
                                "Your subscription will be cancelled on {date}. After this date you won't be able to use Appotime system anymore.",
                        })
                        .replace(
                            '{date}',
                            moment(subscription.currentPeriodEnd * 1000).format('DD.MM.YYYY'),
                        ),
                )
            ) {
                return Promise.resolve();
            }
            setCancelling(true);
            return mutate({
                variables: {
                    input: {
                        salon,
                    },
                },
                refetchQueries: [
                    {
                        query: GET_SUBSCRIPTION_QUERY,
                        variables: {
                            salon,
                        },
                    },
                ],
            }).finally(() => {
                setCancelling(false);
            });
        },
    }),
});

const handlers = withHandlers({
    onCancel: ownProps => () => {
        ownProps.cancelStripeSubscription();
    },
});

const mapStateToProps = ({ user }) => ({
    salon: user.get('salon'),
});

export default compose(
    connect(mapStateToProps),
    injectIntl,
    handlers,
    withData,
    withCancelling,
    withMutation,
    handlers,
)(InvoicesPage);
